<style lang="less" scoped>
.cx-layout .cx-region-north{position: absolute; left: 0; top: 0; right: 0; height: auto; padding: 0; margin: 0;}
.cx-layout .cx-region-west{position: absolute; left: 0; top: 0; bottom: 0; width: auto; padding: 0; margin: 0;}
.cx-layout .cx-region-center{position: absolute; left: 0; top: 0; right: 0; bottom: 0; padding: 0; margin: 0;}
.cx-layout .cx-region-east{position: absolute; top: 0; right: 0; bottom: 0; width: auto; padding: 0; margin: 0;}
.cx-layout .cx-region-south{position: absolute; left: 0; right: 0; bottom: 0; height: auto; padding: 0; margin: 0;}
</style>

<template>
  <div :class="className" :style="style">
    <slot></slot>
  </div>
</template>

<script>
/* 组件-Region */
let PX = 'px;'
export default
{
  /**
   * 调用说明：
   * @prop  {String}  region                region (north / west / center / east / south)
   * @prop  {Number}  [width]               宽度(像素)
   * @prop  {Number}  [height]              高度(像素)
   * @prop  {Boolean} [split = false]       是否有分隔条
   * @prop  {String}  [initStyle = '']      样式
   */
  props:
  {
    region: {type: String, required: true},
    width: {type: Number, default: -1},
    height: {type: Number, default: -1},
    split: {type: Boolean, default: false},
    initStyle: {type: String, default: ''},
    sepSize: {type: Number, default: 10}                  //分隔宽度
  },
  data()
  {
    return {
      index: 4,          //region索引
      autoSize: true,                       //自动大小
      size: -1,                             //大小
      posSize: ''                           //Style 的位置、大小
    }
  },
  computed:
  {
    className()
    {
      return 'cx-region-' + this.region
    },

    style()
    {
      return this.initStyle + this.posSize
    }
  },
  created()
  {
    //确定region索引
    switch (this.region)
    {
    case 'north':     //cx.consts.REG_NORTH
      this.index = 0
      this.size = this.height
      break
    case 'west':      //cx.consts.REG_WEST
      this.index = 1
      this.size = this.width
      break
    case 'east':      //cx.consts.REG_EAST
      this.index = 2
      this.size = this.width
      break
    case 'south':     //cx.consts.REG_SOUTH
      this.index = 3
      this.size = this.height
      break
    case 'center':    //cx.consts.REG_CENTER
    default:
      this.index = 4
      break
    }
    //确定是否自动宽高
    switch (this.index)
    {
    case 0:     //cx.consts.REG_NORTH
    case 3:     //cx.consts.REG_SOUTH
    case 1:     //cx.consts.REG_WEST
    case 2:     //cx.consts.REG_EAST
      if (this.size !== -1)
        this.autoSize = false
      break
    case 4:     //cx.consts.REG_CENTER
      this.autoSize = false
      this.split = false                //center不能split
      break
    }
  },
  watch:
  {
    'width': function(newVal, oldVal)
    {
      this.size = newVal
      this.$parent.update()
    },
    'height': function(newVal, oldVal)
    {
      this.size = newVal
      this.$parent.update()
    }
  },
  methods:
  {
    /**
     * 取 region 大小
     * @method
     * @returns {}
     */
    getSize()
    {
      switch (this.index)
      {
      case 0:     //cx.consts.REG_NORTH
      case 3:     //cx.consts.REG_SOUTH
        if (this.size === -1 && !this.autoSize)
          this.size = this.$el.clientHeight
        if (this.autoSize)
          return this.$el.clientHeight
        else
          return this.size
      case 1:     //cx.consts.REG_WEST
      case 2:     //cx.consts.REG_EAST
        if (this.size === -1 && !this.autoSize)
          this.size = this.$el.clientWidth
        if (this.autoSize)
          return this.$el.clientWidth
        else
          return this.size
      default:
        return 0
      }
    },
    /**
     * 设置 region 的位置/大小
     * @method
     * @param {Array}       regions         region 信息
     * @param {Boolean}     gutters         是否有分隔条
     */
    setPosSize(regions, gutters)
    {
      let posSize = ''
      let north = regions[0]        //cx.consts.REG_NORTH
      let west = regions[1]         //cx.consts.REG_WEST
      let east = regions[2]         //cx.consts.REG_EAST
      let south = regions[3]        //cx.consts.REG_SOUTH
      let northSep = gutters || north.split
      let westSep = gutters || west.split
      let eastSep = gutters || east.split
      let southSep = gutters || south.split
      switch (this.index)
      {
      case 0:     //cx.consts.REG_NORTH
        if (!this.autoSize)
          posSize += 'height:' + north.size + PX
        break
      case 3:     //cx.consts.REG_SOUTH
        if (!this.autoSize)
          posSize += 'height:' + south.size + PX
        break
      case 1:     //cx.consts.REG_WEST
        if (north.com)
          posSize += 'top:' + (north.size + (northSep ? this.sepSize : 0)) + PX
        if (south.com)
          posSize += 'bottom:' + (south.size + (southSep ? this.sepSize : 0)) + PX
        if (!this.autoSize)
          posSize += 'width:' + west.size + PX
        break
      case 2:     //cx.consts.REG_EAST
        if (north.com)
          posSize += 'top:' + (north.size + (northSep ? this.sepSize : 0)) + PX
        if (south.com)
          posSize += 'bottom:' + (south.size + (southSep ? this.sepSize : 0)) + PX
        if (!this.autoSize)
          posSize += 'width:' + east.size + PX
        break
      case 4:     //cx.consts.REG_CENTER
        if (north.com)
          posSize += 'top:' + (north.size + (northSep ? this.sepSize : 0)) + PX
        if (west.com)
          posSize += 'left:' + (west.size + (westSep ? this.sepSize : 0)) + PX
        if (east.com)
          posSize += 'right:' + (east.size + (eastSep ? this.sepSize : 0)) + PX
        if (south.com)
          posSize += 'bottom:' + (south.size + (southSep ? this.sepSize : 0)) + PX
        break
      }
      this.posSize = posSize
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/com/Region.vue